<template>
    <div>
        <v-btn small color="primary" @click="requestDeleteConfirm()">
            <v-icon small class="mr-1">mdi-trash-can-outline</v-icon>
        </v-btn>
        <confirm-dialog :open="confirmDelete.open" header="Leihspieler/in löschen"
                        @reply="processConfirm" query-parameter="confirmVereinDelete">
            {{satzTeil1}}
            <span class="primary--text font-weight-bold">{{spieler.vorname}} {{spieler.nachname}}</span>
            wirklich endgültig löschen?
        </confirm-dialog>
    </div>
</template>

<script>
    import ConfirmDialog from "../../components/navigation/confirmDialog";
    import SPIELER_CHANGE_HANDLER from "../../services/data/spieler/spielerChangeHandler";
    import {Spieler} from "../../services/data/spieler/spieler";

    export default {
        components: {ConfirmDialog},
        name: "paesse-leihe-delete",
        props: ['spieler', 'sportJahr'],
        data: () => ({
            confirmDelete: {
                open: false,
                question: '',
            },
            satzTeil1: '',
        }),
        computed: {
            leiheDauer(){
                const zeitRaum = this.sportJahr.split('_');
                return {from: zeitRaum[0]+"-07-01", until: zeitRaum[1]+"-06-30"};
            }
        },
        methods: {
            requestDeleteConfirm(){
                this.satzTeil1 = this.spieler.geschlecht === 'f' ?
                    "Möchtest du die Leihspielerin " :
                    "Möchtest du den Leihspieler ";
                this.confirmDelete.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.processDeletion();
                }
                this.confirmDelete.open = false;
            },
            async processDeletion(){
                const spielerSave = new Spieler();
                spielerSave.setFromDataObject(this.spieler);
                this.$store.state.local.loader = true;
                spielerSave.local.documentUpdates = SPIELER_CHANGE_HANDLER.getDataObjectForLeiheDelete(
                    this.spieler, this.leiheDauer.from, this.leiheDauer.until);
                await spielerSave.updateWithTransaction('spieler_edit', false);
                this.$store.state.local.loader = false;
            }
        },
    }
</script>

<style scoped>

</style>